var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"player"},[_c('video-player',{ref:"videoPlayer",staticClass:"vjs-custom-skin",attrs:{"options":_vm.playerOptions,"playsinline":true},on:{"ended":function($event){return _vm.onPlayerEnded($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }